import { render, staticRenderFns } from "./website-builder.vue?vue&type=template&id=f7c5bb24&scoped=true&"
import script from "./website-builder.vue?vue&type=script&lang=js&"
export * from "./website-builder.vue?vue&type=script&lang=js&"
import style0 from "./website-builder.vue?vue&type=style&index=0&id=f7c5bb24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c5bb24",
  null
  
)

export default component.exports